import NotificationService from '../../services/notifications';

export default new NotificationService();
